/**
 * Configuración centralizada de la API
 *
 * En producción, siempre usa rutas relativas (/api)
 * En desarrollo con Vite dev server, usa variables de entorno
 */

// Detectar entorno en RUNTIME basándonos en el hostname
// Si estamos en localhost:3000 (Vite dev server), es desarrollo
// Cualquier otro dominio o puerto, es producción
const isDevServer = () => {
  // En producción (build servido por Express), process.env.NODE_ENV es 'production'
  return process.env.NODE_ENV === 'development'
}

let API_URL

if (isDevServer()) {
  // Desarrollo con Vite dev server (localhost:3000)
  // Conectar al backend en puerto 5000
  API_URL = 'http://localhost:5001/api'
  console.log('🔧 Modo Desarrollo - API:', API_URL)
} else {
  // Producción o acceso directo al servidor
  // Usar ruta relativa (funcionará con cualquier dominio)
  API_URL = '/api'
  console.log('🚀 Modo Producción - API:', API_URL, '- Hostname:', window.location.hostname)
}

export { API_URL }
export default API_URL
